<template>
  <div>
    <v-overlay :value="dataReady">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
    </center>
    <v-card>
      <v-img
        @click="Home()"
        :lazy-src="imageUrlBack"
        max-height="30"
        max-width="100"
        :src="imageUrlBack"
      ></v-img>
    </v-card>
    <v-container fluid>
      <v-card-title class="header_1">
        ประกันกลุ่ม
        <v-spacer></v-spacer>
      </v-card-title>
      <v-row justify="space-around">
        <v-col
          elevation="10"
          v-for="rounded in ['xl']"
          :key="rounded"
          cols="12"
          md="6"
        >
          <v-sheet
            elevation="10"
            :rounded="rounded"
            style="background-color: #26a69a"
            class="mx-auto"
            height="160"
            width="256"
          >
            <v-row align="end" class="fill-height">
              <v-col class="py-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="text_color">
                      {{ dataHealth.empHealthName || "ไม่พบข้อมูล" }}
                    </v-list-item-title>
                    <v-col class="py-0">
              <v-list-item-title class="text_color2">
                <strong>{{ dataHealth.healthGroupNumber }}</strong>
              </v-list-item-title>
            </v-col>
            <center>
              <v-btn text color="#FFFFFF">
                {{ profile.empFull_NameTH }} </v-btn
              ><br />
            </center>

                    <v-divider class="mx-2" color="#FFFFFF"></v-divider>

                    <v-col cols="12">
                      <v-list-item-subtitle
                        :value="computedDate1"
                        :return-value.sync="date"
                        >เริ่ม :{{ showDate1 || "-" }}</v-list-item-subtitle
                      >
                      <v-list-item-subtitle
                        :value="computedDate2"
                        :return-value.sync="date"
                        >หมดอายุ :{{ showDate2 || "-" }}</v-list-item-subtitle
                      >
                    </v-col>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date

export default {
  components: {
    moment
  },
  computed: {
    computedDate1 () {
      if (this.dataHealth.healthGroupStartDate) {
        let dateTh4 = moment(this.dataHealth.healthGroupStartDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDate1 = dateTh4
        return this.showDate1
      }
    },
    computedDate2 () {
      if (this.dataHealth.healthGroupEnd) {
        let dateTh4 = moment(this.dataHealth.healthGroupEnd)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDate2 = dateTh4
        return this.showDate2
      }
    }
  },
  data () {
    return {
      profile: [],
      cards: [
        { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 }
      ],
      dataReady: true,
      imageLogo: '',
      imageBackground: '',
      showDateTH: '',
      showDate1: '',
      showDate2: '',
      date: new Date().toISOString().substr(0, 10),
      dataHealth: [],
      // End Export Config
      imageHeadHRM: '',
      imageUrlBack: ''
    }
  },
  async mounted () {
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageLogo = require('@/assets/logosso.png')
    await this.getDataByHealth()
  },
  methods: {
    async getDataByHealth () {
      this.dataHealth = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee_group_insurance_line/' +
            'getEmpCode?empCode=' +
            this.profile.empCode
        )
        .then(async (response) => {
          console.log('response', response)
          this.dataReady = false
          if (response.data) {
            this.dataHealth = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
        })
    },
    Home () {
      this.$router.push('/Liff/HomeWelfare')
    }
  }
}
</script>
<style scoped>
.header {
  font-family: Kanit;
  font-size: 25px;
  display: flex;

  color: #871b12;
}
.header_1 {
  font-family: Kanit;
  font-size: 20px;
  display: flex;

  color: #871b12;
}
.text_color {
  color: #871b12;
}
.text_color2 {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/GroupInsurance.vue